export const BIZCHAT_HOST_OCDI = 'm365copilotapp.svc.cloud.microsoft';
export const BIZCHAT_RESOURCE_OCDI = 'https://m365copilotapp.svc.cloud.microsoft';
